import { ReportsModal } from '@/shared/components/reports-modal'
import { FiFile, FiUser } from 'react-icons/fi'
import { useLoaderData } from 'react-router-dom'

export const CompanyReports = () => {
  const { data: companyReportColumns } = useLoaderData()

  const reportOptions = [
    {
      label: 'Tabla de contratistas',
      description:
        'Descarga la información de la tabla de contratistas. Puedes seleccionar las columnas',
      value: 'company',
      icon: FiUser,
      columns: companyReportColumns
    },
    {
      label: 'Listado de documentos',
      description:
        'Descarga el listado de documentos asociados.',
      value: 'company_attachments',
      icon: FiFile,
      columns: []
    }
  ]

  return <ReportsModal reportOptions={reportOptions} />
}
